import React from 'react';
import PropTypes from 'prop-types';
import { useAuth0 } from '../../auth0-wrapper';
import InternalServerError from '../error-pages/InternalServerError';
import NotAuthorized from '../error-pages/NotAuthorized';
import { ROLES } from '../common/access-control/rbac';

const MustLogin = ({ children }) => {
  const { isAuthenticated, loginWithRedirect, loading, user } = useAuth0();

  if (isAuthenticated && user) {
    const { roles, tenant } = user['https://dap.covis.de'];

    if (
      roles.length === 0 ||
      (!roles.includes(ROLES.PORTAL_ADMIN) && !tenant)
    ) {
      return <NotAuthorized />;
    }
    return children;
  }

  // If the login failed stop login redirects.
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('error') && searchParams.has('state')) {
    if (searchParams.get('error') === 'unauthorized') {
      return <NotAuthorized />;
    }
    return <InternalServerError />;
  }

  // Wait for the application to stabilize
  // When we get called back with ?code=XXX from auth0 we do not want to call again login and go into loops
  if (!loading) {
    loginWithRedirect();
  }

  return null;
};

MustLogin.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default MustLogin;
